import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import RunSheetDetails from './RunSheetUpdate';
import RescheduleDetails from './Reschedule';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface RunSheet {
    tab: string;
    idList: number[];
    loading: boolean;
}

export class RunSheetData extends React.Component<RouteComponentProps<{}>, RunSheet> {
    constructor(props: any) {
        super(props);

        this.state = {
            tab: "RunSheet",
            idList: [],
            loading: true
        };
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=ViewRunSheetUpdates&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                this.setState({ loading: false });
            } else {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    goReschedule = (data: any) => {
        this.setState({ tab: "Reschedule", idList: data.idList });
    }

    goRunSheet = () => {
        this.setState({ tab: "RunSheet" });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var contents;
        if (this.state.tab == "RunSheet") {
            contents = <RunSheetDetails saveReschedule={this.goReschedule} />
        }
        else if (this.state.tab == "Reschedule") {
            contents = <RescheduleDetails idList={this.state.idList} save={this.goRunSheet} />
        }


        return (
            <div>
                <div className="tabsComponent" id="tab-container">
                    <div>
                        {contents}
                    </div>
                </div>

            </div>
        );

    }

};